import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecurityObject } from 'src/app/models/security.model';
import { UtilsResource } from 'src/app/resources/UtilsResource.resource';
import { keysUniversal } from 'src/app/resources/keys.resources';
import { ActionsEventsService } from 'src/app/services/actions-events/actions-events.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { GeneralUtilService } from 'src/app/services/general-util/generalUtil.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { StoreServiceLibrary } from 'src/app/services/store/store.service';
import { matchValidator } from 'src/app/services/validators/form-validators';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;
  componentHaveAllResources = false;
  inProcess = false;


  showForm = false;
  isRegister = false;

  isShowPassword: boolean;
  isShowConfirmPsw: boolean;

  appDownloadIos = 'https://apps.apple.com/us/app/miles-by-gennius/id6458534931';
  appDownloadAndroid = 'https://play.google.com/store/apps/details?id=com.mbyg.miles';

  showButtonStartNow = false;

  messageErrorService = '';
  showMessageError = false;


  regexConfig;
  messageMustContain;
  disabledPasswordRegister;

  constructor(
    // private _authService: AuthService,
    private _general: GeneralService,
    private _storeLibrary: StoreServiceLibrary,
    private _eventsService: ActionsEventsService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private generalUtilService: GeneralUtilService,
    private route: ActivatedRoute,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    // UNIVERSAL
    let universalIsLoad = false;
    universalIsLoad = this._general.stringToBoolean(this._storeLibrary.getIsUniversalLoad() + '');
    if (universalIsLoad && !this.componentHaveAllResources) {
      this.componentHaveAllResources = true;
      this.loadThingsDependingUniversal();
    }
    this._eventsService.universalLoadSubject.subscribe((load) => {
      if (load && !this.componentHaveAllResources) {
        this.componentHaveAllResources = true;
        this.loadThingsDependingUniversal();
      }
    });
    // UNIVERSAL

    this.route.queryParams
      .subscribe(
        params => {
          this.showButtonStartNow = this._general.stringToBoolean(params?.showRegister);
        }
      );
  }

  showFormB() {
    this.showForm = true;
    this.isRegister = false;
  }

  loadThingsDependingUniversal() {
    let objectConfig = this.getConfigPassword();
    if (objectConfig?.messageModal) {
      this.messageMustContain = objectConfig.messageModal['en'];
    } else {
      this.messageMustContain = 'It must contain at least 8 characters, including a lowercase letter, an uppercase letter, a number and a special character. The following characters are not allowed <div class="alert-password">' + ' ^ ` ¡ ° ´, ç ñ ? ;  ¿ ÷ </div>"'
    }
    this.buildForm();
  }

  closeModalError() {
    this.showMessageError = false;
  }

  buildForm() {
    this.registerForm = this.formBuilder.group(
      {
        name: ['', [Validators.required, Validators.pattern(/^([a-zA-ZÀ-ÿ]*)*[a-zA-ZÀ-ÿ \''‘-]+$/)]],
        lastName: ['', [Validators.required, Validators.pattern(/^([a-zA-ZÀ-ÿ]*)*[a-zA-ZÀ-ÿ \''‘-]+$/)]],
        email: ['', [Validators.required, Validators.email]],
        // phone: ['', [Validators.required, Validators.pattern(/[0-9]*/)]],
        password: ['', [
          Validators.required,
          Validators.pattern(this.regexConfig),
          matchValidator('confirmPassword', true)],
        ],
        confirmPassword: ['', [
          Validators.required,
          Validators.pattern(this.regexConfig),
          matchValidator('password')],
        ],
        confirmCheck: [false, [Validators.requiredTrue]]
      },
      // {
      //   validator: MustMatch("password", "confirmPassword")
      // }
    );
  }

  showPassword() {
    this.isShowPassword = !this.isShowPassword;
  }

  showConfirmPsw() {
    this.isShowConfirmPsw = !this.isShowConfirmPsw;
  }

  openUrl(type) {
    if (type === 'ios') {
      window.open(this.appDownloadIos, '_blank');
    } else {
      window.open(this.appDownloadAndroid, '_blank');
    }
  }

  openTyC() {
    const url = this._storeLibrary.getJustOneUniversalPropertie(keysUniversal.app_url_terms_and_conditions_en);
    window.open(url, '_blank');
  }

  register() {
    if (this.inProcess) {
      return;
    }
    if (this.registerForm.invalid) {
      return;
    }
    const request = {
      channelId: this._storeLibrary.getJustOneUniversalPropertie(keysUniversal.app_channel_id_mr) !== ''
        ? this._storeLibrary.getJustOneUniversalPropertie(keysUniversal.app_channel_id_mr)
        : this._storeLibrary.getJustOneUniversalPropertie(keysUniversal.app_channel_id),
      language: 'en',
      firstName: this.registerForm.get('name').value,
      lastName: this.registerForm.get('lastName').value,
      email: this.registerForm.get('email').value,
      password: this.registerForm.get('password').value,
      passwordConfirm: this.registerForm.get('confirmPassword').value,
      // security: SecurityObject.getSecurityObject()
      security: this.generalUtilService.getSecurityObject()
    };
    this.inProcess = true;
    this.authService.registerWebV2(request).subscribe((response: any) => {
      this.inProcess = false;
      UtilsResource.ShowLog('RegisterPage - register', response);
      if (response.result.code && response.result.code == '200') {
        this.isRegister = true;
        this.showForm = false;
        window.scrollTo(0, 0);
      } else if (response.result.code && response.result.code == '500') {
        // this.msg('Warning', 'Oops! Register is temporarily unavailable. Please try again in a few minutes.');
        this.showMessageError = true;
        this.messageErrorService = 'Oops! Register is temporarily unavailable. Please try again in a few minutes.';
      } else {
        // this.msg('Warning', response.result.message);
        this.showMessageError = true;
        this.messageErrorService = 'Oops! Register is temporarily unavailable. Please try again in a few minutes.';
      }

    }, (error) => {
      this.inProcess = false;
      this.showMessageError = true;
      this.messageErrorService = 'Oops! Register is temporarily unavailable. Please try again in a few minutes.';
      UtilsResource.ShowLog('RegisterPage - register - error', error);
    });
  }

  getConfigPassword() {
    let configPassword;
    try {
      configPassword = JSON.parse(this._storeLibrary.getJustOneUniversalPropertie('_CONFIGURATIONS') || 'false');
      if (configPassword) {
        configPassword = configPassword?.configurations?.web?.passwords;
        this.regexConfig = this._storeLibrary.getJustOneUniversalPropertie(`${configPassword?.keySearchRegex}`);
      }
    } catch (error) {
      configPassword = false;
    }
    return configPassword;
  }

  isCorrectPasswordByRegex(password: string) {
    let regexPass;
    if (typeof this.regexConfig != 'undefined' && this.regexConfig.length > 0) {
      regexPass = this.regexConfig;
    } else {
      regexPass = this._storeLibrary.getJustOneUniversalPropertie(keysUniversal.regex_password);
    }
    // const regexPass = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\\^@|!#$%&/=???~{}+*_.,:;\(\)\[\]\-\\<>])([A-Za-z\d\^@|!#$%&/=???~{}+*_.,:;\(\)\[\]\-\\<>]){8,20}$";
    const re = new RegExp(regexPass, "g");
    return re.test(String(password));
  }

  isValidPassword(password) {
    const valuePass = this.isCorrectPasswordByRegex(password.value);
    if (!valuePass) {
      this.disabledPasswordRegister = true;
    }
  }
}